<template>
    <div class="club-profile">
        <div class="profile-header">
            <div class="header-content">
                <div class="club-avatar" :style="clubAvatarStyle">
                    <template v-if="clubInfo.avatar_address">
                        <img :src="clubInfo.avatar_address" style="width: 100%; height: 100%; border-radius: 50%; background-color: white; border: 1px solid #e0e0e0;" />
                    </template>
                    <template v-else>
                        {{ clubInfo.name ? clubInfo.name.charAt(0).toUpperCase() : '' }}
                    </template>
                </div>
                <div class="club-basic-info">
                    <h1 class="club-name">
                        {{ clubInfo.name }}
                    </h1>
                    <div class="club-types-container">
                        <span v-for="(type, index) in parsedClubTypes" :key="index" class="club-type">
                            {{ type }}
                        </span>
                    </div>
                    <p class="club-intro">{{ clubInfo.intro }}</p>
                </div>
                <div class="action-buttons">
                    <el-button v-if="canJoinClub" @click="joinClub">Join Club</el-button>
                    
                </div>
            </div>
        </div>

        
    </div>
</template>

<script>
import { getStoreClub } from '@/api/eclub'
import { getUserType } from '@/utils/store'

export default {
    name: 'ClubProfile',
    data() {
        return {
            clubInfo: {},
            loading: true,
            shareDialogVisible: false,
            shareLink: ''
        }
    },
    computed: {
        clubAvatarStyle() {
            return {
                backgroundColor: '#e6e6e6',
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '32px',
                fontWeight: 'bold',
                color: '#666'
            }
        },
        canJoinClub() {
            return getUserType() === 'student'
        },
        parsedClubTypes() {
            if (!this.clubInfo.type) return []

            // If it's already an array, return it
            if (Array.isArray(this.clubInfo.type)) {
                return this.clubInfo.type
            }

            // If it's a string that looks like JSON array, parse it
            if (typeof this.clubInfo.type === 'string') {
                const trimmed = this.clubInfo.type.trim()
                if (trimmed.startsWith('[')) {
                    try {
                        const parsed = JSON.parse(trimmed)
                        return Array.isArray(parsed) ? parsed : [this.clubInfo.type]
                    } catch (e) {
                        return [this.clubInfo.type]
                    }
                }
                // Return as single item array
                return [this.clubInfo.type]
            }

            return []
        }
    },
    created() {
        this.fetchClubInfo()
    },
    methods: {
        fetchClubInfo() {
            const club_id = this.$route.query.club_id
            if (!club_id) {
                this.$message.error('Club ID is missing')
                return
            }

            this.loading = true
            getStoreClub(club_id)
                .then(res => {
                    this.clubInfo = res.data.data
                })
                .catch(err => {
                    this.$message.error('Failed to load club information')
                })
                .finally(() => {
                    this.loading = false
                })
        },
        formatDate(dateString) {
            if (!dateString) return 'Not specified'
            return new Date(dateString).toLocaleDateString()
        },
        viewClubDetail() {
            this.$router.push({
                name: 'Club Detail',
                query: {
                    club_id: this.$route.query.club_id
                }
            })
        },
        joinClub() {
            // TODO: Implement join club functionality
            this.$message.info('Join club feature coming soon')
        },

    }
}
</script>

<style lang="scss" scoped>
.club-profile {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 90px);

    .profile-header {
        background: white;
        border-radius: 8px;
        padding: 24px;
        margin-bottom: 24px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);

        .header-content {
            display: flex;
            align-items: flex-start;
            gap: 24px;

            .club-basic-info {
                flex: 1;

                .club-name {
                    font-size: 24px;
                    margin: 0 0 12px;
                }

                .club-types-container {
                    display: flex;
                    flex-wrap: wrap;
                    gap: 8px;
                    margin-bottom: 12px;

                    .club-type {
                        font-size: 13px;
                        color: #666;
                        background: #f5f7fa;
                        padding: 6px 14px;
                        border-radius: 14px;
                        border: 1px solid #e4e7ed;
                        white-space: nowrap;
                    }
                }

                .club-intro {
                    color: #666;
                    line-height: 1.5;
                }
            }
        }
    }

    .profile-content {
        .info-card, .stats-card {
            margin-bottom: 20px;

            .card-header {
                font-weight: bold;
                color: #303133;
            }
        }

        .info-list {
            .info-item {
                display: flex;
                margin-bottom: 16px;
                
                .label {
                    color: #909399;
                    width: 140px;
                }

                .value {
                    color: #303133;
                    flex: 1;
                }
            }
        }

        .stats-list {
            display: flex;
            justify-content: space-around;
            text-align: center;

            .stat-item {
                .stat-value {
                    font-size: 24px;
                    font-weight: bold;
                    color: #409EFF;
                }

                .stat-label {
                    color: #909399;
                    margin-top: 8px;
                }
            }
        }
    }

    .action-buttons {
        display: flex;
        gap: 12px;
    }

    .share-link-container {
        .share-input {
            margin-bottom: 12px;
        }

        .share-hint {
            color: #909399;
            font-size: 14px;
            margin: 0;
        }
    }
}
</style> 